import { useLegalEntityRegions } from '../../../hooks/useUser';
import { useDocumentCenterData } from '../utils/hooks';
import { RegionFilter } from '../../../components/RegionFilter';

export const DocumentRegionFilter = () => {
  const regions = useLegalEntityRegions();
  const { documents } = useDocumentCenterData();

  const regionCodesWithDocs = new Set(
    documents
      .map((doc) => doc.region_code)
      .filter((code): code is string => !!code),
  );

  const filteredRegions = regions.filter((region) =>
    regionCodesWithDocs.has(region.code),
  );

  return (
    <RegionFilter
      regions={filteredRegions}
      ariaButtonText="Change documents location filter:"
      menuItemLabelPrefix="Filter documents to"
    />
  );
};
